<template>
  <ContainerWrapper>
    <OffersList
      title="Saque Aniversário FGTS"
      :description="cptdSectionDescription"
    >
      <SegueOfferCardContainer
        v-if="cptdDisplaySegueOffer"
        key="SEGUE"
        :offer="cptdSegueOffer"
      />
      <BvOfferCardContainer v-if="cptdDisplayBvFgts" key="BV" />
      <UppOfferCardContainer v-if="cptdDisplayUppFgts" key="UPP" />
      <template v-if="cptdDisplayFakeOffers">
        <ProductEmptyStateOfferCard
          v-for="offer in cptdEmptyStateOffers"
          :key="offer.amount"
          :amount="offer.amount"
          :duration="offer.duration"
          :interest-rate="offer.interestRate"
          product="FGTS"
          form-path="/forms/emprestimo/fgts/simular"
        >
          <template #duration>Descontado do FGTS</template>
        </ProductEmptyStateOfferCard>
      </template>
      <FeedbackBannerCard v-if="cptdDisplayNoResultEmptyState">
        <template #icon>
          <BaseIcon name="search-mono" size="sm" />
        </template>
        <template #title>Não há ofertas</template>
        <template #description>
          Tente novamente após ter saldo disponível no FGTS.
        </template>
      </FeedbackBannerCard>
      <FgtsNoResultFeedbackDialogContainer
        v-if="displayNoResultFeedbackDialog"
        :display="displayNoResultFeedbackDialog"
        @close="displayNoResultFeedbackDialog = false"
      />
    </OffersList>
  </ContainerWrapper>
</template>
<script>
import { mapGetters } from 'vuex'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import OffersList from '@/components/appForm/loanResults/OffersList.vue'
import BvOfferCardContainer from '@/containers/loans/fgts/offer/affiliates/bv/BvOfferCardContainer.vue'
import UppOfferCardContainer from '@/containers/loans/fgts/offer/affiliates/upp/UppOfferCardContainer.vue'
import ProductEmptyStateOfferCard from '@/components/loans/ProductEmptyStateOfferCard.vue'
import FeedbackBannerCard from '@/components/commomComponents/feedback/FeedbackBannerCard.vue'
import BaseIcon from '@/aasgard/components/base/BaseIcon.vue'
import FgtsNoResultFeedbackDialogContainer from '@/containers/forms/loans/fgts/FgtsNoResultFeedbackDialogContainer.vue'
import SegueOfferCardContainer from '~/containers/loans/fgts/offer/partners/SegueOfferCardContainer.vue'

export default {
  name: 'FgtsOffersListContainer',
  components: {
    SegueOfferCardContainer,
    FgtsNoResultFeedbackDialogContainer,
    BaseIcon,
    FeedbackBannerCard,
    ProductEmptyStateOfferCard,
    UppOfferCardContainer,
    ContainerWrapper,
    OffersList,
    BvOfferCardContainer,
  },
  data() {
    return {
      displayNoResultFeedbackDialog: false,
      currentUtmCampaign: sessionStorage.getItem('utm_campaign') || '',
    }
  },
  computed: {
    ...mapGetters({
      gtUser: 'user/user/gtUser',
      gtAllOngoingFgtsOffers: 'products/loans/fgts/gtAllOngoingFgtsOffers',
      gtFgtsLastSimulationDate: 'products/loans/fgts/gtFgtsLastSimulationDate',
      gtFgtsLatestSimulationRequest:
        'products/loans/fgts/gtFgtsLatestSimulationRequest',
    }),
    cptdHasOngoingOffers() {
      return this.gtAllOngoingFgtsOffers.length > 0
    },
    cptdEmptyStateOffers() {
      return [
        {
          amount: 1000,
          duration: 0,
          interestRate: 1.49,
        },
        {
          amount: 500,
          duration: 0,
          interestRate: 1.49,
        },
        {
          amount: 300,
          duration: 0,
          interestRate: 1.49,
        },
        {
          amount: 100,
          duration: 0,
          interestRate: 1.49,
        },
      ]
    },
    cptdDisplayAffiliates() {
      return this.cptdDisplayBvFgts || this.cptdDisplayUppFgts
    },
    cptdDisplayBvFgts() {
      return false // disabled for now
    },
    cptdDisplayUppFgts() {
      return (
        !this.currentUtmCampaign.includes('credfacil-emprestimo') &&
        !!this.gtFgtsLastSimulationDate &&
        this.gtFgtsLatestSimulationRequest?.fgts_balance > 50
      )
    },
    cptdSegueOffer() {
      return this.gtAllOngoingFgtsOffers.find(
        (offer) => offer.partner === 'SEGUE',
      )
    },
    cptdDisplaySegueOffer() {
      return !!this.cptdSegueOffer
    },
    cptdDisplayFakeOffers() {
      return !this.gtFgtsLastSimulationDate
    },
    cptdDisplayNoResultEmptyState() {
      return (
        !this.cptdDisplayFakeOffers &&
        !this.cptdDisplayUppFgts &&
        !this.cptdDisplayBvFgts &&
        !this.cptdDisplaySegueOffer
      )
    },
    cptdSectionDescription() {
      if (!this.cptdDisplayFakeOffers) return ''
      return 'Para saber se você está elegível, faça uma simulação.'
    },
  },
  mounted() {
    this.checkLastSimulationResult()
  },
  methods: {
    checkLastSimulationResult() {
      const { last_product_simulation } = this.$route?.query || {}
      this.displayNoResultFeedbackDialog =
        last_product_simulation === 'fgts' &&
        !this.cptdDisplaySegueOffer &&
        !this.cptdDisplayAffiliates
    },
  },
}
</script>
<style lang="scss"></style>
